module.exports = __webpack_public_path__ + "img/employees.c2444ec1.svg";